// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17BFJ","question":"styles_question__1xxho","description":"styles_description__2m6UQ"};